import PressHeading from '../../sections/PressHeading/index';
import PressContact from '../../sections/PressContact/index';
import PressTagCarousel from '../../sections/PressTagCarousel/index';
import PressContactForm from '../../components/PressContactForm';
import ArticleTileCustom from '../../components/ArticleTileCustom';
import RevealThumbs from '../../components/RevealThumbs';

PressHeading();
PressContact();
PressTagCarousel();
PressContactForm();
ArticleTileCustom();
RevealThumbs();
